<template>
  <FaIcon :icon="['fas', ICON.SENSOR]" />
</template>

<script setup lang="ts">
import { ICON } from '@/constants/icons';

defineOptions({ name: 'ZoneIcon' });
</script>
